exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect.form-control.multiselect[data-v-3f54e6fe] {\n    padding: 0;\n}\n@media (max-width: 768px) {\n.card-header-mobile[data-v-3f54e6fe] {\n        background-color: #82B1FF !important;\n        color: #FFFFFF !important;\n}\n}\n", ""]);

// exports
